export default __webpack_public_path__ + "static/Montserrat-Medium-c416eeaec33891f7c0081be1acd57151.woff2";